import "./_sidebar.scss";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import profilePic from "assets/profile.png";
import DarkMode from "components/DarkMode/DarkMode";

// Icons
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PortraitOutlinedIcon from "@mui/icons-material/PortraitOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";

const navItems = [
  { to: "/", label: "Home", icon: <HomeOutlinedIcon /> },
  { to: "/about", label: "About", icon: <PortraitOutlinedIcon /> },
  { to: "/skills", label: "Skills", icon: <DevicesOutlinedIcon /> },
  { to: "/experience", label: "Experience", icon: <BusinessCenterOutlinedIcon /> },
  { to: "/portfolio", label: "Portfolio", icon: <WebOutlinedIcon /> },
  { to: "/contact", label: "Contact", icon: <DraftsOutlinedIcon /> },
];

const socialLinks = [
  { href: "https://www.facebook.com/profile.php?id=100055147804181", icon: <FacebookOutlinedIcon /> },
  { href: "https://www.instagram.com/usman_arif_13", icon: <InstagramIcon /> },
  { href: "https://www.linkedin.com/in/muhammad-usman-51a946201", icon: <LinkedInIcon /> },
  { href: "https://github.com/MuhammadUsmanAnsari", icon: <GitHubIcon /> },
];

function SocialRow() {
  return (
    <div className="social-row">
      {socialLinks.map((s, i) => (
        <a key={i} href={s.href} target="_blank" rel="noreferrer">{s.icon}</a>
      ))}
    </div>
  );
}

export default function Sidebar() {
  const location = useLocation();

  // Close offcanvas on route change via direct DOM cleanup.
  // Using Bootstrap's instance.hide() queues a 300ms animation — if React Router
  // navigates before that animation finishes, Bootstrap never removes the backdrop
  // div, leaving a permanent dark overlay over the whole app.
  useEffect(() => {
    const offcanvasEl = document.getElementById("sidebarOffcanvas");
    if (offcanvasEl && offcanvasEl.classList.contains("show")) {
      offcanvasEl.classList.remove("showing", "show");
      offcanvasEl.removeAttribute("aria-modal");
      offcanvasEl.setAttribute("aria-hidden", "true");
      offcanvasEl.style.visibility = "";
      // Remove the dark backdrop Bootstrap injects into <body>
      document.querySelectorAll(".offcanvas-backdrop").forEach((el) => el.remove());
      // Remove body overflow lock Bootstrap sets while offcanvas is open
      document.body.classList.remove("offcanvas-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    }
  }, [location.pathname]);

  // ── Desktop sidebar ──────────────────────────────────────────────────────

  const DesktopSidebar = (
    <nav className="sidebar-nav h-100">
      <div className="dm-toggle-wrap">
        <DarkMode />
      </div>

      <div className="sidebar-profile">
        <div className="profile-ring">
          <img src={profilePic} alt="Usman Arif" />
        </div>
        <p className="profile-name">Usman Arif</p>
        <p className="profile-title">Full Stack Developer</p>
      </div>

      <div className="sidebar-divider" />

      <div className="sidebar-links">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) => `nav-item-link${isActive ? " active" : ""}`}
          >
            <span className="nav-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </div>

      <div className="sidebar-social">
        <SocialRow />
      </div>
    </nav>
  );

  // ── Mobile navbar ─────────────────────────────────────────────────────────

  const MobileNav = (
    <>
      <div className="mobile-navbar">
        <Link to="/" className="mobile-brand">
          <div className="brand-avatar">
            <img src={profilePic} alt="Usman Arif" />
          </div>
          <span>Usman Arif</span>
        </Link>
        <div className="mobile-right">
          <DarkMode />
          <button
            className="hamburger-btn"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#sidebarOffcanvas"
            aria-controls="sidebarOffcanvas"
          >
            <MenuIcon fontSize="small" />
          </button>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-start sidebar-offcanvas"
        data-bs-scroll="true"
        data-bs-backdrop="true"
        tabIndex="-1"
        id="sidebarOffcanvas"
      >
        <div className="offcanvas-header">
          <div className="offcanvas-profile">
            <div className="oc-avatar">
              <img src={profilePic} alt="Usman Arif" />
            </div>
            <div>
              <p className="oc-name">Usman Arif</p>
              <p className="oc-title">Full Stack Developer</p>
            </div>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">
          {/* No data-bs-dismiss on NavLinks — Bootstrap's dismiss blocks React Router.
              The useEffect above closes the offcanvas after navigation completes. */}
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => `oc-nav-link${isActive ? " active" : ""}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
          <div className="oc-social">
            <SocialRow />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="d-none d-md-block h-100">{DesktopSidebar}</div>
      <div className="d-block d-md-none">{MobileNav}</div>
    </>
  );
}
